import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes, UrlSegment } from '@angular/router';
import { HomePage } from './pages/home/home.page';
import { OrderPage } from './pages/order/order.page';
import { MyOrdersPage } from './pages/my-orders/my-orders.page';
import { PaymentSuccessPage } from './pages/payment-success/payment-success.page';
import { MenuPage } from './pages/menu/menu.page';
import { EmailConfirmationPage } from './pages/email-confirmation/email-confirmation.page';
import { AccountPage } from './pages/account/account.page';
import { ModalNavigationGuard } from './modal-navigation-guard';
import { EmailActionPage } from './pages/email-action/email-action.page';
import { MaintenancePage } from './pages/maintenance/maintenance.page';
import { signUpSuccessPage } from './pages/sign-in-order/sign-in-order.page';
import { CheckOrderGuard } from './guard/check-order-guard';
import { NAVIGATIONURLS } from './services/navigation.service';
import { SelectVenuePage } from './pages/select-venue/select-venue.page';
import { provideRouter, withComponentInputBinding } from '@angular/router';
const routes: Routes = [
	{
		path: '',
		redirectTo: HomePage.url,
		pathMatch: 'full',
		canDeactivate: [ModalNavigationGuard],
	},

	{
		path: HomePage.scanUrl,
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: OrderPage.cancelUrlWithPaymentParam,
		redirectTo: OrderPage.paymentCancelUrl,
	},
	{
		path: OrderPage.failUrlWithPaymentParam,
		redirectTo: OrderPage.paymentFailUrl,
	},
	{
		path: HomePage.url,
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: SelectVenuePage.url,
		loadChildren: () => import('./pages/select-venue/select-venue.module').then(m => m.SelectVenuePageModule),
	},
	{
		path: EmailConfirmationPage.url,
		loadChildren: () => import('./pages/email-confirmation/email-confirmation.module').then(m => m.EmailConfirmationPageModule),
	},
	{
		path: MenuPage.url,
		loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuPageModule),
		canActivate: [CheckOrderGuard],
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: PaymentSuccessPage.urlWithPaymentParam,
		loadChildren: () => import('./pages/payment-success/payment-success.module').then(m => m.SuccessPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: PaymentSuccessPage.url,
		loadChildren: () => import('./pages/payment-success/payment-success.module').then(m => m.SuccessPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: OrderPage.paymentFailUrl,
		loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: OrderPage.paymentCancelUrl,
		loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: OrderPage.url,
		loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: signUpSuccessPage.url,
		loadChildren: () => import('./pages/sign-in-order/sign-in-order.module').then(m => m.signUpSuccessPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: MyOrdersPage.url,
		loadChildren: () => import('./pages/my-orders/my-orders.module').then(m => m.MyOrdersPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: EmailConfirmationPage.url,
		loadChildren: () => import('./pages/email-confirmation/email-confirmation.module').then(m => m.EmailConfirmationPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: AccountPage.url,
		loadChildren: () => import('./pages/account/account.module').then(m => m.AccountPageModule),
		canDeactivate: [ModalNavigationGuard],
	},
	{
		path: MaintenancePage.url,
		loadChildren: () => import('./pages/maintenance/maintenance.page.module').then(m => m.MaintenancePageModule),
	},
	{
		path: EmailActionPage.url,
		loadChildren: () => import('./pages/email-action/email-action.module').then(m => m.EmailActionPageModule),
	},
	{
		path: NAVIGATIONURLS.cookie(),
		loadChildren: () => import('./pages/cookie/cookie.module').then(m => m.CookiePageModule),
	},
	{
		path: NAVIGATIONURLS.promo(),
		loadChildren: () => import('./pages/promotions/promotions.module').then(m => m.PromotionsPageModule),
	},
	{
		path: '**',
		redirectTo: '/',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })],
	exports: [RouterModule],
	providers: [provideRouter(routes, withComponentInputBinding())],
})
export class AppRoutingModule {}
